import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';

import {
  Paper,
  Typography,
  Grid,
  Button,
  Avatar,
  Hidden,
} from '@material-ui/core';

import FavoriteIcon from '@material-ui/icons/FavoriteBorderOutlined';
import BookmarkIcon from '@material-ui/icons/BookmarkBorderOutlined';
import PrintIcon from '@material-ui/icons/PrintOutlined';

import ErrorDialog from '../../common/components/ErrorDialog';
import ActivityDeleteDialog from '../../activities/components/ActivityDeleteDialog';
import InterestRequestDialog from '../../activities/components/InterestRequestDialog';

import * as constants from '../../config/constants';
import * as activitesActions from '../../activities/actions';
import classes from '../../css/getCSS';
import coverPhoto from '../../assets/img/cover.jpg';


class ProfileIntro extends Component {
  state = {
    deleteDialog: false,
    activityDialog: false,
    activityType: null,
    confirmVisible: true,
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  shortlist = () => {
    this.props.shortlist(
      this.props.token,
      this.props.match.params.uuid,
    );
  }

  toggleActivityDialog = (type) => {
    this.setState({
      activityDialog: !this.state.activityDialog,
      activityType: type,
      confirmVisible: true,
    });
  }

  toggleDeleteDialog = (type) => {
    this.setState({
      deleteDialog: !this.state.deleteDialog,
      activityType: type,
    });
  }

  inputChangedHandler = (event, field) => {
    let form = null;
    if (this.state.activityType === 'interests') {
      form = 'interestForm';
    } else {
      form = 'requestForm';
    }
    this.props.inputChangedHandler(
      event,
      field,
      form,
      this.props[form],
    );
  }

  submitHandler = (event) => {
    this.setState({
      confirmVisible: false,
    });
    let form = null;
    if (this.state.activityType === 'interests') {
      form = 'interestForm';
    } else {
      form = 'requestForm';
    }
    this.props.submitHandler(
      event,
      form,
      this.props[form],
      this.props.token,
      this.state.activityType,
      this.props.match.params.uuid,
    );
  }

  render() {
    const avatarURL = constants.BASE_URL + this.props.profile.avatar_md;

    let interestButton = (
      <Button
        fullWidth
        variant="flat"
        className={classes.profileActionButton}
        onClick={() => this.toggleActivityDialog('interests')}
      >
        <FavoriteIcon />
        Send Interest
      </Button>
    );

    if (this.props.profile.interest.sent || this.props.interested) {
      interestButton = (
        <Button
          fullWidth
          color="primary"
          variant="flat"
          className={classes.profileActionButton}
          onClick={() => this.toggleDeleteDialog('interests')}
        >
          <FavoriteIcon />
          Interest Sent
        </Button>
      );
    }

    // let requestButton = (
    //   <Button
    //     fullWidth
    //     variant="flat"
    //     className={classes.profileActionButton}
    //     onClick={() => this.toggleActivityDialog('requests')}
    //   >
    //     <RequestIcon />
    //     Send Request
    //   </Button>
    // );

    // if (this.props.profile.request.sent || this.props.requested) {
    //   requestButton = (
    //     <Button
    //       fullWidth
    //       variant="flat"
    //       color="primary"
    //       className={classes.profileActionButton}
    //       onClick={() => this.toggleDeleteDialog('requests')}
    //     >
    //       <RequestIcon />
    //       Request Sent
    //     </Button>
    //   );
    // }

    let shortlistButton = (
      <Button fullWidth variant="flat" className={classes.profileActionButton} onClick={this.shortlist}>
        <BookmarkIcon />
        Shortlist
      </Button>
    );

    if (this.props.profile.shortlisted || this.props.shortlisted) {
      shortlistButton = (
        <Button
          fullWidth
          color="primary"
          variant="flat"
          className={classes.profileActionButton}
          onClick={() => this.toggleDeleteDialog('shortlists')}
        >
          <BookmarkIcon />
          Shortlisted
        </Button>
      );
    }

    let actionButtons = <br />;
    if (!this.props.profile.is_editable && this.props.profile.is_complete) {
      actionButtons = (
        <Paper className={[classes.card, classes.noBorderXS, classes.profileActionCard].join(' ')}>
          <Grid container>
            <Grid item md={6} sm={6} xs={6}>
              {interestButton}
            </Grid>
            {/* <Grid item md={4} sm={4} xs={6}>
              {requestButton}
            </Grid> */}
            <Grid item md={6} sm={6} xs={6}>
              {shortlistButton}
            </Grid>
          </Grid>
        </Paper>
      );
    }

    let lastActive = null;
    if (this.props.profile.last_login) {
      lastActive = (<Typography variant="subheading" style={{ color: '#fff' }}>Last active: {this.props.profile.last_login}</Typography>);
    }
    let dateJoined = null;
    if (this.props.profile.date_joined) {
      dateJoined = (<Typography variant="subheading" style={{ color: '#fff' }}>Date Joined: {this.props.profile.date_joined}</Typography>);
    }

    const profileCover = {
      padding: '10px',
      backgroundImage: `url(${coverPhoto})`,
      backgroundSize: 'cover',
      position: 'relative',
    };

    let message = null;
    if (!this.props.profile.is_complete) {
      message = (
        <Typography variant="subheading" style={{ color: 'red' }}>
          This profile is still inactive. <br />
          The candidate has not completed their profile on the new website.
          <br />
          You cannot send any interest or request to this candidate.
        </Typography>
      );
    }

    return (
      <React.Fragment>
        <div style={profileCover}>
          {this.props.profile.is_complete
            ? (
              <Button onClick={() => this.props.printProfile()} variant="extendedFab" size="small" className={classes.floatingPrint}>
                <PrintIcon style={{ marginRight: '5px' }} />
                <Hidden xsDown>Print Profile</Hidden>
              </Button>
            ) : null}
          <Grid container>
            <Grid item md={4} xs={12} sm={3} className={classes.coverWrapper}>
              <Avatar
                alt={this.props.profile.profile_id}
                src={avatarURL}
                className={classes.profileAvatar}
                style={{ border: '2px solid #fff' }}
              />
            </Grid>
            <Grid item md={8} xs={12} sm={9} className={classes.coverWrapper}>
              <Typography variant="headline" style={{ color: '#fff' }}>{this.props.profile.basicinfo.first_name} {this.props.profile.basicinfo.last_name}</Typography>
              <Typography variant="headline" style={{ color: '#fff' }}>{this.props.profile.profile_id}</Typography>
              {lastActive}
              {dateJoined}
            </Grid>
          </Grid>
        </div>
        {actionButtons}
        {message}
        <ErrorDialog open={this.props.hasError} handleClose={this.props.toggleError}>
          {this.props.error}
        </ErrorDialog>
        <ActivityDeleteDialog
          open={this.state.deleteDialog}
          type={this.state.activityType}
          close={this.toggleDeleteDialog}
        />
        <InterestRequestDialog
          open={this.state.activityDialog}
          type={this.state.activityType}
          close={this.toggleActivityDialog}
          actionLoading={this.props.actionLoading}
          actionError={this.props.actionError}
          submitHandler={this.submitHandler}
          inputChangedHandler={this.inputChangedHandler}
          interestForm={this.props.interestForm}
          requestForm={this.props.requestForm}
          interested={this.props.interested}
          requested={this.props.requested}
          confirmVisible={this.state.confirmVisible}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    error: state.activities.error,
    hasError: state.activities.hasError,

    interestForm: state.activities.interestForm,
    requestForm: state.activities.requestForm,
    actionLoading: state.activities.actionLoading,
    actionError: state.activities.actionError,

    shortlisted: state.activities.shortlisted,
    interested: state.activities.interested,
    requested: state.activities.requested,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(activitesActions.onUnmount()),
    toggleError: () => dispatch(activitesActions.toggleError()),
    shortlist: (token, slug) => dispatch(activitesActions.shortlistAction(token, slug)),
    inputChangedHandler: (event, field, form, inputs) => dispatch(
      activitesActions.inputChangedHandler(event, field, form, inputs),
    ),
    submitHandler: (event, form, inputs, token, type, slug) => dispatch(
      activitesActions.submitHandler(event, form, inputs, token, type, slug),
    ),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileIntro));



// WEBPACK FOOTER //
// ./src/profile/components/ProfileIntro.js